
import { config } from './config';
import { styles } from './styles';
import { BackgroundEffects } from './components';
 
export default {
  config,
  styles,
  components: {
    BackgroundEffects
  }
};